import React, { useEffect, useState } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { useSuppliers } from '../../hooks'
import { SuppliersEntity } from '../../interfaces/Supplier/Supplier'

interface SuppliersDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  valueKey?: 'supplierId' | 'supplierName'
  required?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | undefined
  allowedWarehouseIds?: number[]
  productOriginId?: number
  error?: boolean
  errorText?: string
}

export const SuppliersDDL: React.FC<SuppliersDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  valueKey = 'supplierId',
  required = false,
  disabled = false,
  size,
  allowedWarehouseIds,
  productOriginId,
  error = false,
  errorText = 'Seleccionar Proveedor'
}) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const {
    suppliersState: { suppliers },
    getSuppliers
  } = useSuppliers()

  useEffect(() => {
    if (suppliers?.length === 0) {
      getSuppliers()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value < 1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrSuppliers =
    suppliers !== undefined
      ? suppliers
          .filter((item) =>
            allowedWarehouseIds && allowedWarehouseIds.length > 0
              ? item.warehouseIds.some((wid: number) =>
                  allowedWarehouseIds.includes(wid)
                )
              : true
          )
          .filter((item) =>
            productOriginId != null
              ? item.productOriginId === productOriginId
              : true
          )
          .map((option: SuppliersEntity) => (
            <MenuItem key={option[valueKey]} value={option[valueKey]}>
              {option.supplierName}
            </MenuItem>
          ))
      : []

  const isError = () => {
    return hasError || error
  }

  return (
    <TextField
      variant={type}
      id='supplierId'
      name='supplierId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      disabled={disabled}
      size={size}
      error={isError()} // Aplicar el estado de error al TextField
      helperText={isError() ? errorText : undefined}
    >
      <MenuItem key={0} value={0}>
        {'Seleccione Proveedor ...'}
      </MenuItem>
      {arrSuppliers}
    </TextField>
  )
}
